import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../../redux/features/searchCategorySlice";
import { useNavigate, useParams } from "react-router-dom";

function Category() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const lang = useSelector((state) => state.language.lang);
  // Destructure both parent's categories and child categories from the store
  const { childCategories, categories } = useSelector((state) => state.categories);
  const { categoryId } = useParams();
  const [visibleCount, setVisibleCount] = useState(6);

  useEffect(() => {
    if (categoryId) {
      // If a parent category is selected, fetch its child categories.
      dispatch(fetchCategories({ lang, parent_id: categoryId }));
    } else {
      // No categoryId means we want to show parent's categories.
      dispatch(fetchCategories(lang));
    }
  }, [dispatch, lang, categoryId]);

  // Determine which set of categories to display.
  // If a categoryId exists, we display childCategories; otherwise, display parent's categories.
  const displayedCategories = categoryId ? childCategories : categories;

  const handleCategoryClick = (category) => {
    if (category.child_count === 0) {
      // If no further children exist, navigate to the shop page
      navigate(`/shops?category_id=${category.id}&parent_category_id=${category.parent_id}`);
    } else {
      // Otherwise, fetch and display the next level (child categories)
      dispatch(fetchCategories({ lang, parent_id: category.id }));
      navigate(`/category/${category.id}`);
    }
  };

  return (
    <>
      <section className="cart-page-section pt-100 pb-80 main-bg">
        {displayedCategories && displayedCategories.length > 0 ? (
          <div className="categories-grid">
            {displayedCategories.slice(0, visibleCount).map((category) => (
              <div key={category.id} className="category-card">
                <a
                  href={`/category/${category.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleCategoryClick(category);
                  }}
                >
                  <img src={category.image} alt="No Image"
                    onError={(e) => {
                      e.target.onerror = null; // prevents infinite loop
                      e.target.src = "https://amzio.de/api/uploads/products/no-thumbnail.png";
                    }}
                    className="category-image" />
                  <h6 className="category-title">{category.title}</h6>
                </a>
              </div>
            ))}
            {displayedCategories.length > visibleCount && (
              <button
                className="theme-btn style-one show-more-btn"
                onClick={() => setVisibleCount(visibleCount + 3)}
              >
                Show More
              </button>
            )}
          </div>
        ) : (
          <div>No categories available</div>
        )}
      </section>

      <style jsx>{`
        .categories-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr); /* Three columns */
          gap: 20px; /* Spacing between cards */
          margin: 0 auto;
          max-width: 1200px; /* Adjust width if necessary */
          padding: 20px;
        }
        .show-more-btn {
          grid-column: 1 / -1; /* Makes the button span across all columns */
          justify-self: center; /* Centers the button horizontally */
          margin-top: 20px;
        }
        .category-card {
          background: #fff;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          text-align: center;
          padding: 15px;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .category-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
        }
        .category-image {
          width: 300px;
          height: 300px;
          object-fit: cover;
          margin-bottom: 10px;
          border-radius: 4px;
        }
        .category-title {
          font-size: 16px;
          font-weight: bold;
          color: #333;
        }
        @media (max-width: 768px) {
          .categories-grid {
            grid-template-columns: repeat(2, 1fr); /* Two columns for tablets */
          }
        }
        @media (max-width: 480px) {
          .categories-grid {
            grid-template-columns: 1fr; /* One column for mobile */
          }
        }
      `}</style>
    </>
  );
}

export default Category;
